export default __webpack_public_path__ + "static/nuig-5c0c4136a058292a892d74e67b7c97c5.webp";